/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const ai_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#ai_medium_svg__a)"
    >
      <path d="M16.625 13.723c-4.988 1.681-6.632 3.553-7.848 8.214-1.216-4.661-2.86-6.533-7.848-8.214 4.988-1.68 6.632-3.552 7.848-8.213 1.216 4.661 2.86 6.533 7.848 8.213Zm6.188-7.774c-2.814.944-3.741 1.995-4.427 4.614-.686-2.619-1.614-3.67-4.427-4.614 2.813-.945 3.74-1.996 4.427-4.615.686 2.619 1.613 3.67 4.427 4.615Zm.365 13.614c-2.082.684-2.769 1.446-3.276 3.344-.508-1.898-1.195-2.66-3.277-3.344 2.082-.685 2.769-1.447 3.277-3.344.507 1.897 1.194 2.66 3.276 3.344Z" />
    </g>
    <defs>
      <clipPath id="ai_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default ai_medium
